import api from './api';

const expenseAnalysisService = {
  // Get expense analysis data
  getExpenseAnalysis: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.categoryId) params.append('categoryId', filters.categoryId);
      if (filters.department) params.append('department', filters.department);
      if (filters.status) params.append('status', filters.status);

      const queryString = params.toString();
      const url = `/expense-analysis/analysis${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error getting expense analysis:', error);
      throw error;
    }
  },

  // Get filter options
  getFilterOptions: async () => {
    try {
      const response = await api.get('/expense-analysis/filters');
      return response.data;
    } catch (error) {
      console.error('Error getting filter options:', error);
      throw error;
    }
  }
};

export default expenseAnalysisService;

